angular.module("utilizzatore.components", [])
    .component("utilizzatore", {
        templateUrl: 'ng/components/riepilogoEControllo/utilizzatore/utilizzatore.view.html',
        bindings: {
            model: '<',
            verifica: '=',
            contatti: '=',
            readOnly: '<',
            exportValidity: '&'
        },
        controller: Utilizzatore,
        controllerAs: 'utilizzatoreCtrl'
    })

function Utilizzatore(
    $configService,
    $typeDomainService,
    $scope,
    $timeout
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            legalStatuses: [],
            sae: [],
            rae: []
        }

        self.loader = {
            legalStatus: false,
            sae: false,
            rae: false
        }
        $timeout(function () {
            self.checkValidityContact();
        }, 1000);
        getAllDomaniSet();
    }

    self.check = function (el) {
        el.selected = !el.selected;
        if (el.selected) {
            el.ndg = $configService.getUser().ndg;
            el.identifier = $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        } else {
            el.ndg = "";
            el.identifier = "";
            el.dataConferma = "";
        }

    }

    var getAllDomaniSet = function () {
        self.loader = {
            legalStatus: true,
            sae: true,
            rae: true
        }
        $typeDomainService
            .getAllLegalStatuses()
            .then(function (legalStatuses) {
                self.supportModel.legalStatuses = legalStatuses;
                self.loader.legalStatus = false;
            })
        $typeDomainService
            .getSaeByLegalStatus(self.model.formaGiuridica)
            .then(function (saeList) {
                self.supportModel.sae = saeList;
                self.loader.sae = false;
            })
        $typeDomainService
            .getRaeBySae(self.model.sae)
            .then(function (raeList) {
                self.supportModel.rae = raeList;
                self.loader.rae = false;
            })

    };

    self.getLegalStatusDescription = function (legalStatusCode) {
        if (self.supportModel.legalStatuses && legalStatusCode) {
            var result = self.supportModel.legalStatuses.find(function (legalStatus) {
                return legalStatus.id == legalStatusCode.toUpperCase()
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';
    }

    self.getSaeDescription = function (saeCode) {
        if (self.supportModel.sae) {
            var result = self.supportModel.sae.find(function (sae) {
                return sae.id == saeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';

    }

    self.getRaeDescription = function (raeCode, raeFromCerved) {

        if (self.supportModel.rae) {
            var result = self.supportModel.rae.find(function (rae) {
                return rae.id == raeCode
            });
            return result ? result.id + ' - ' + result.description : '-';
        } else return '-';

    }

    self.checkValidityContact = function () {


        var test = $scope.contactUtilizzatore && $scope.contactUtilizzatore.$valid;

        self.exportValidity({
            value: test
        });

    }
}